import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "age",
  standalone: false,
})
export class AgePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}
  transform(birthday: string | Date): unknown {
    let date = this.datePipe.transform(birthday, "yyyy-MM-dd");
    const result = moment().diff(moment(date), "years");
    return result;
  }
}
